module.exports = __webpack_public_path__ + "static/media/martin_crypto.4f146b1f.jpg";